import { useState } from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { TextField, Box, Typography } from '@mui/material';

import moment from 'moment';

// import './time-range-picker.scss';

const TimeRangePickerGeneric = ({ setStart, setEnd, onChange }) => {
  const [start, setStartState] = useState(moment().startOf('day'));
  const [end, setEndState] = useState(
    moment().endOf('day').subtract(4, 'minutes')
  );
  const handleChange = (options, name) => {
    if (options !== null && options !== undefined) {
      if (name === 'start') {
        if (setStart) {
          setStart(options);
        }

        setStartState(options);
      } else if (name === 'end') {
        if (setEnd) {
          setEnd(options);
        }

        setEndState(options);
      }
      onChange();
      // console.log(options.format('hh:mm a'));
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        // flexDirection: 'row',
        justifyContent: 'space-evenly',

        padding: '10px',
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginY: '10px',
        height: '80px',
      }}
    >
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <TimePicker
          minutesStep={5}
          onChange={(options) => handleChange(options, 'start')}
          label={'Start'}
          ampm
          value={start ? start : moment().startOf('day')}
          renderInput={(params) => <TextField {...params} />}
          sx={{ zIndex: 0 }}
        />
        <Typography variant="h6" sx={{ px: '2%', color: '#2E4053', pt: 1 }}>
          to
        </Typography>
        <TimePicker
          ampm
          minutesStep={5}
          label={'End'}
          clearable
          onChange={(options) => handleChange(options, 'end')}
          value={end}
          minTime={start}
          renderInput={(params) => <TextField {...params} />}
          sx={{ zIndex: 0 }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default TimeRangePickerGeneric;

// console.log(moment("12:15 PM", ["h:mm A"]).isBetween(moment("11:00 AM", ["hh:mm A"]), moment("11:00 PM", ["hh:mm A"]), "minutes"));
